import './highlights.scss'
import {CardMedia} from '@mui/material'
import {CurrencyExchangeRounded as CurrencyExchangeIcon} from '@mui/icons-material'
import {isEmpty} from 'react-lf-tools'
import {useNavigate} from 'react-router-dom'
import {setSession} from '../../../hooks/useStorage/useStorage.jsx'
import {prices} from '../../../utils/utils.jsx'

const Highlights = ({highlights}) => {
    const navigate = useNavigate()

    const isVariousPrices = (highlight) => (
        (highlight.visibility.includes('DIGITALMENU')) &&
        (!isEmpty(highlight.visibleStepOne) && highlight.visibleStepOne) &&
        (!isEmpty(highlight.variations)) &&
        (!isEmpty(highlight.prices))
    )

    const handleClick = (highlight) => {
        setSession('positionPage', window.scrollY)
        navigate('/produto', {state: {product: highlight, edit: false, item: {}}})
        console.table(highlight)
    }

    if (!highlights.length) return <div/>

    return <div className={'highlights'} id={'destaques'}>
        {highlights.map(highlight => {
            return <div key={highlight.product} className={'div-highlights'}
                        onClick={() => handleClick(highlight)}>
                <CardMedia
                    className={'card-media-highlight'}
                    image={highlight.image}
                />
                <div className={'div-description-highlights'}>
                    <div>
                        <label className={'product'}>
                            {highlight.product}
                        </label>
                        <div className={'div-description-cashback'}>
                            <label className={'description'}>
                                {highlight.description}
                            </label>
                            {(highlight.cashback !== 0 && highlight.cashback !== undefined) &&
                                <div className={'div-icon-cashback'}>
                                    <label className={'label-cashback'}>
                                        {`${highlight.cashback.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })} Cashback`}
                                    </label>
                                    <CurrencyExchangeIcon className={'icon-list-products'}/>
                                </div>}
                        </div>
                    </div>
                    <div className={'div-prices'}>
                        {(highlight.oldPrice !== 0 && highlight.oldPrice !== undefined) &&
                            <label className={'price-old'}>
                                {highlight.oldPrice.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })}
                            </label>
                        }
                        {(() => {
                            if (isVariousPrices(highlight)) {
                                return <div>
                                    {prices(highlight.prices).map((p, i) => <div key={i}
                                                                                 className={'div-prices-products'}>
                                        <label className={'price'}>
                                            {`${p.price.toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}  ${p.description}`}
                                        </label>
                                    </div>)}
                                </div>
                            } else {
                                return <div className={'div-price-cashback'}>
                                    <label className={'price'}>
                                        {(highlight.price !== 0) ? `${highlight.price.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}` : 'R$ ***'}
                                    </label>
                                </div>
                            }
                        })()}
                    </div>
                </div>
            </div>
        })}
    </div>
}

export default Highlights
